module.exports = __webpack_public_path__ + "static/img/taxcellent_banner_h5.c5f6104.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/publicDetail/taxcellent_banner_h5.png
// module id = qwhH
// module chunks = 34